import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { Check } from 'lucide-react';

const Technology = () => {
  const { content } = useLanguage();
  const { technologyData, ui } = content;

  return (
    <section id="tecnologia" className="py-20 lg:py-32 bg-gradient-to-b from-black via-gray-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {technologyData.title}
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            {technologyData.description}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-16">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src={technologyData.image}
                alt={ui.technology.imageAlt}
                className="w-full h-auto object-cover rounded-2xl"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-blue-600/20 to-transparent"></div>
            </div>
            
            {/* Glow effects */}
            <div className="absolute -top-4 -left-4 w-64 h-64 bg-blue-600/20 rounded-full blur-3xl -z-10"></div>
            <div className="absolute -bottom-4 -right-4 w-64 h-64 bg-blue-800/20 rounded-full blur-3xl -z-10"></div>
          </div>

          {/* Steps */}
          <div className="space-y-6 order-1 lg:order-2">
            {technologyData.steps.map((step, index) => (
              <div
                key={step.id}
                className="relative pl-8 pb-8 border-l-2 border-gray-800 last:border-transparent last:pb-0"
              >
                {/* Step number */}
                <div className="absolute -left-4 top-0 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {step.id}
                </div>

                {/* Content */}
                <div>
                  <h3 className="text-2xl font-semibold text-white mb-2">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Detection Capabilities */}
        <div className="mt-16 p-10 bg-gradient-to-br from-blue-950/30 to-gray-950/30 border border-blue-900/30 rounded-3xl">
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4 text-center">
            {ui.technology.detectionTitle}
          </h3>
          <p className="text-gray-400 text-center mb-8 max-w-3xl mx-auto">
            {ui.technology.detectionSubtitle}
          </p>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {technologyData.detectionCapabilities.map((capability, index) => (
              <div
                key={index}
                className="flex items-center bg-gray-900/50 border border-gray-800 rounded-lg px-4 py-3 hover:border-blue-600/50 transition-all duration-200 hover:transform hover:scale-105"
              >
                <Check className="text-blue-400 mr-2 flex-shrink-0" size={16} />
                <span className="text-gray-300 text-sm">{capability}</span>
              </div>
            ))}
          </div>

          {/* Bottom note */}
          <div className="mt-8 text-center">
            <p className="text-blue-400 font-semibold">
              {ui.technology.detectionFooter}
            </p>
          </div>
        </div>

        {/* Technology visualization */}
        <div className="mt-12 p-12 bg-gradient-to-br from-gray-900 to-gray-950 border border-gray-800 rounded-3xl">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {ui.technology.metrics.map((metric) => (
              <div key={metric.label}>
                <div className="text-4xl font-bold text-blue-400 mb-2">{metric.value}</div>
                <div className="text-sm text-gray-400">{metric.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technology;
